<template>
  <div>
    <div :class="!ifFullScreen ? 'container' : ''">
      <vue-draggable-resizable drag-handle=".ant-card-head" class="wrap summaryDialog" :id="ifFullScreen ? 'fullscreenDialog' : ''" :w="dragW" :h="dragH" v-if="showMode">
        <a-card class="summaryInformation autoh-table-wrapper onePictureDialog dy3dDialog">
          <div slot="title" class="headerClass">
            <span>汇总信息</span>
            <div class="oprateBtn">
              <a-button class="exportBtn" :loading="exportLoading" @click="exportInfo">导出</a-button>
              <a-button class="collectBtn" :loading='collectLoading' @click="saveInfo">收藏</a-button>
              <span @click="fullScreen()"><a-icon :type="ifFullScreen ? 'fullscreen-exit' : 'fullscreen'" style="color: aliceblue; cursor: pointer; margin-right:10px" /></span>
              <span @click="miniSize()"><a-icon type="minus" style="color: aliceblue; cursor: pointer" title='最小化'/></span>
              <span @click="close()"><a-icon type="close" style="color: aliceblue; cursor: pointer" /></span>
            </div>
          </div>
          <div class="contentInfo">
            <div class="polygons" v-if="tabArry.length > 1">
              <span v-for="item in tabArry" :key="item.bsm" @click="polygonChange(item.bsm)" :class='activeTab == item.bsm ? "activePolygon" : ""'>{{item.name}}
                <a-divider type="vertical"/>
              </span>
            </div>

            <div class="tabBtns">
              <span id="btn1" :class="activeTabInfo == '1' ? 'primaryBtn' : 'btn'" @click="tableBtnChange('1')">统计信息</span>
              <span id="btn2" :class="activeTabInfo == '2' ? 'primaryBtn' : 'btn'" @click="tableBtnChange('2')">详情</span>
              <img :src="require('@/assets/images/treeIcon.png')" alt="" v-if="activeTabInfo == '1'" title='树展示' @click="showTree" style="float:right; margin-top:12px; cursor:pointer">
            </div>

            <div class="tables">
              <a-table
                v-if="activeTabInfo == '1'"
                class="tableHeaderClass summaryInfoTable"
                :id="currentTabInfo.bsm"
                ref="table"
                bordered
                size="middle"
                :rowKey="(record, index) => { return index }"
                :scroll="{ x: 800, y: tableHeight }"
                :customRow="rowClickTjxx"
                :columns="columnsAll"
                :data-source="currentTabInfo.data"
                :pagination="false"
                :loading="tableLoading"
              >
                <!-- <template v-for="(item,i) in flColSlots" :slot="item" slot-scope="text, record">
                  <span @click="clickCell(record,item)" :key='i' style="display:inline-block; width:100%">{{text}}</span>
                </template> -->
                <template slot="action" slot-scope="text, record">
                  <span>
                    <a class="primaryColor" style="color: #ffd614" @click="() => clickTableTrDetail(record)">详情</a>
                  </span>
                </template>
              </a-table>

              <a-table
                v-if="activeTabInfo == '2'"
                class="tableHeaderClass summaryDetailInfoTable"
                :id="currentTabInfo.bsm + 'detail'"
                ref="table"
                bordered
                size="middle"
                rowKey="bsm"
                :scroll="{ x: 800, y: tableHeight, scrollToFirstRowOnChange: true }"
                :customRow="rowClickDetail"
                :columns="columnsDetail"
                :data-source="tableData2"
                :pagination="ipagination"
                @change="handleTableChange"
                :loading="tableLoading2"
              >
                <span slot="action" slot-scope="text, record">
                  <span v-if="!record.hj">
                    <a class="primaryColor" style="color: #ffd614" @click="() => toCheckDetail(record)">详细</a>
                  </span>
                </span>
              </a-table>
            </div>
          </div>
        </a-card>
        <saveAnalysis-dialog ref="saveAnalysisDialog" :selectLayerBsm="selectLayerBsm" :myCollectionTreeData='myCollectionTreeData' v-on="$listeners"></saveAnalysis-dialog>
        <screen-shot-dialog ref="screenShotDialog" @handleShot="handleShot"></screen-shot-dialog>
      </vue-draggable-resizable>
    </div>

    <mars-modal ref="marsModal" @closeDetails="closeDetails"></mars-modal>
    <static-info-tree-dialog ref='staticInfoTreeDialog' :map='map' :fwArry='fwArry' :activeTab='activeTab' @showTable='showTable' @showDetailsByAttr='showDetailsByAttr'></static-info-tree-dialog>
  </div>
</template>
  
<script>
  import 'proj4leaflet'
  import { thousands } from '../../../../utils/util.js'
  const esri = require('esri-leaflet')
  // import { postHeadersAction_ds, downFilePost_ds, getAction } from '../../../../api/manage'
  import { HandleTableCells } from '../../../../mixins/HandleTableCells'
  import { queryGeomByAttr } from "../../../../utils/queryGeomByAttr.js";
  // 保存分析结果的弹框
  import saveAnalysisDialog from './saveAnalysisDialog.vue'
  import MarsModal from '../../../components/hzfxMarsModel.vue'
  import screenShotDialog from './screenShotDialog.vue'
  import staticInfoTreeDialog from './staticInfoTreeDialog.vue'
  // 分类字段名称用于详情表格的合并
  var flzdmc
  export default {
    name: 'summaryInformation',
    components: {
      MarsModal,
      saveAnalysisDialog,
      screenShotDialog,
      staticInfoTreeDialog
    },
    mixins: [HandleTableCells],
    data() {
      return {
        pageKey:'', // 页面对应的key  'djfx'-叠加分析  'hcfx'-缓冲分析  专题bsm-专题分析
        geoserverUrl:'',
        ifFullScreen:false, // 是否全屏
        clickTimer: null,
        singleClick:true, // 表格是否单击
        tableHeight:300,
        resizeObserver: null,
        showMode: false,
        dragW: 900,
        dragH: 450,
        tableLoading: false,
        tableLoading2: false,
        showSingeDetail: false,  // 是否展示某个分类的详情数据
        showAllDetail: false,  // 是否展示所有分类的详情数据（如果点击的是表格上面的详情按钮，就是true）
        exportLoading: false,
        collectLoading: false,
        map: null,
        tabArry: [],
        currentTabInfo:{},
        activeTab: null,
        activeTabInfo: '1',  // 1统计信息  2详情
        columnsAll: [],
        columnsDetail: [],
        flColSlots:[], // 分组字段
        flAttrs:{}, // 分类字段的键值对 (点击统计信息表格行详情调查询接口的时候需要；或者点击表格行的详情后，点击导出调接口需要)
        ipagination: {
          current: 1,
          pageSize: 20,
          pageSizeOptions: ['20', '40', '80'],
          showTotal: (total, range) => {
            return range[0] + '-' + range[1] + ' 共' + total + '条'
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0,
        },
        // 统计字段名称数组
        tjzdArry: [],
        tableData: [],
        tableData2: [],
        // 选中表格样式
        highlightRow: '',
        highlightRow2: '',
        // 组装详情接口的condition入参值
        condition: null,
        // 组装详情接口的gemos入参值
        layerParams: [],
        // 统计信息表格 点击的某一行数据
        tjxxTrInfo:{},
        // 详情临时图层
        graphicLayer: null,
        // 导出BSM
        exportBsm: null,
        // 导出名称
        reportName: null,
        // 导出地类编码
        myDlbm: null,
        // 要保存的框选范围数据
        fwArry: [],
        hturl: {
          // 查询详情数据
          getDetail: '/hzfx/getAnalyseDetail',
          // 专题分析 查询详情数据
          getZtfxDetail: '/hzfx/getZtfxAnalyseDetail',
          // 点击每一条数据继续查详情
          getAnalyseOneDetail: '/hzfx/getAnalyseOneDetail',
          // 导出汇总分析统计信息
          exportAll: '/hzfx/exportTjInfo',
          // 导出汇总分析统计信息(专题分析)
          exportZtfxAll: '/hzfx/exportZtfxTjInfo',
          // 导出汇总分析统计详情信息
          exportDetail: '/hzfx/exportTjInfoDetail',
          // 导出汇总分析统计信息(专题分析)
          exportZtfxDetail: '/hzfx/exportZtfxTjInfoDetail',
        },
        //选择的算法
        methodsQuery: '',
        //图层名称
        layerName: '',
        layerData: null,
        operate:'',  // 用户操作，是收藏还是导出
      }
    },
    created() {},
    props: {
      // 选择的图层bsm
      selectLayerBsm: {
        type: String,
        default: '',
      },
      // 专题分析-点击的专题的bsm
      projectBsm: {
        type: String,
        default: '',
      },
      // 专题分析-点击的专题名称
      ztName: {
        type: String,
        default: '',
      },
      /** 
       * @param {string} dialogTitle 分析弹框的标题 —— 叠加分析/缓冲分析/专题分析
       */
      dialogTitle: {
        type: String,
        default: '',
      },
      /** 
       * @param {arr} layerLists 选择图层的下拉框数据（平级的 图层数据）
       */
      layerLists:{
        type: Array,
        default: () => [],
      },
      myCollectionTreeData:{
        type: Array,
        default: () => [],
      }
    },
    mounted () {
      this.$bus.$on('completeCheckDetail',(detailInfo) => {
        this.tableLoading2 = false
        this.tableData2 = detailInfo.data
        this.ipagination.total = parseInt(detailInfo.dataInfoSize)
        this.$nextTick(()=>{
          let infoDetail = {
            colLength:this.columnsDetail.length,
            mergeColIndex:this.calculateMergeCol(this.columnsDetail.filter(e => e.type == 'fl').length),
            startChangeBgIndex:this.columnsDetail.filter(e => e.type == 'fl').length - 2,
            rowClass:'.summaryDetailInfoTable .ant-table-scroll .ant-table-tbody tr',
            ifNeedMergeCol:'false'
          }
          this.mergeCells(infoDetail)
          this.calculateTableHeight()
        })
      });
      this.$bus.$on('completeCheckLayerAttrs', (attrInfo,params) => {
        this.tableLoading2 = false
        let geojson = JSON.parse(attrInfo.geom)
        this.reLoadGraphic()
        this.addDemoGraphic1(this.graphicLayer, geojson.coordinates[0][0])
        let attributes = []
        if(this.dialogTitle == '专题分析'){
          attributes = this.layerLists.filter(e => e.alias.split(':')[1].indexOf(params.tcmc) > -1 ).length > 0 ? 
                       this.layerLists.filter(e => e.alias.split(':')[1].indexOf(params.tcmc) > -1 )[0].attributes : 
                       []
        }else{
          attributes = this.layerData.attributes
        }
        this.$refs.marsModal.showModal(attrInfo, '详情查看', attributes)
      })
    },
    beforeDestroy () {
      this.$bus.$off('completeCheckDetail');
      this.$bus.$off('completeCheckLayerAttrs');
    },
    methods: {
      /** 
       * 初始化弹框信息
       * @param {object} info 内容包括：
       * @param {arr} info.msg 配置统计信息
       * @param {arr} info.fwArry 选择分析范围数据
       * @param {arr} info.resData 分析接口返回的统计信息数据
       * @param {arr} info.layerParams 组装详情接口的gemos入参值  
       * 例如 —— [{bsm:'', geom:'POLYGON Z ((121.331655 32.484873 -158.9, 121.319558 32.342379 -82.7, 121.459997 32.362177 -75.6, 121.331655 32.484873 -158.9))', name:'多边形'}]
       * @param {object} info.map 地图数据
       * @param {number} info.methods 选择的算法
       * @param {object} info.layerData 选择的图层数据
       * @param {string} info.pageKey 页面key 'djfx'-叠加分析  'hcfx'-缓冲分析  专题bsm-专题分析
       * @param {string} info.geoserverUrl  geoserver服务对应的配置地址
       */
      setMap(info) {
        let {msg, fwArry, resData, layerParams, map, methods, layerData, pageKey} = info
        console.log('统计信息', info)
        this.showMode = true
        this.pageKey = pageKey
        this.geoserverUrl = info.geoserverUrl
        this.activeTabInfo = '1'
        this.map = map
        this.fwArry = fwArry
        this.condition = msg
        this.layerParams = layerParams
        this.methodsQuery = methods
        if(this.dialogTitle == '专题分析' && layerData.dataName == '综合'){
          this.layerName = this.layerLists.map(item => item.alias.split(':')[1]).join(',') 
        }else{
          this.layerName = layerData.alias ? layerData.alias.split(':')[1] : ''
        }
        this.layerData = layerData
        this.tabArry = resData
        this.activeTab = this.tabArry[0].bsm
        this.exportBsm = this.tabArry[0].bsm
        this.reportName = this.tabArry[0].name
        this.currentTabInfo = this.tabArry[0]
        this.columnsAll = []
        this.columnsDetail = []
        this.tjzdArry = []
        this.flColSlots = []
        let tableHeader = JSON.parse(JSON.stringify(msg))
        let flHeader = tableHeader.filter(e => e.isfl)  // 分组字段
        let tjHeader = tableHeader.filter(e => e.istj)  // 统计字段
        let showHeader = tableHeader.filter(e => !e.isfl && !e.istj)  // 显示字段（除去分组字段和统计字段）
        let tjxxNewHeader = [...flHeader,...tjHeader]
        // 组装 统计信息表头（需要加小计合计）
        for (var item of tjxxNewHeader) {
          let obj = {}
          obj.dataIndex = item.mc.toLowerCase()
          if (item.isfl) {
            // 分组字段
            obj.align = 'center'
            obj.type = 'fl'
            obj.title = item.alias
            obj.scopedSlots = { customRender: obj.dataIndex }
            this.columnsAll.push(obj)
            this.flColSlots.push(obj.dataIndex)
          } else if (item.istj) {
            // 统计字段
            obj.align = 'right'
            obj.type = 'tj'
            if(item.unit){
              if(item.unit.indexOf('元') > -1){
                obj.title = `${item.alias}(万元)`
              }else{
                obj.title = `${item.alias}(公顷)`
              }
            }else{
              obj.title = item.alias
            }
            obj.customRender = (text) => {
              return thousands(text,'false')
            }
            this.columnsAll.push(obj)
            this.tjzdArry.push(item.mc.toLowerCase())
          }
        }
        this.columnsAll.push({
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'center',
        })
        
        // 组装 详情表头
        let xqNewHeader = [...flHeader,...tjHeader,...showHeader]
        for (var menu of xqNewHeader) {
          let obj2 = {}
          obj2.dataIndex = menu.mc.toLowerCase()
          if (menu.isfl) {
            // 分组字段
            obj2.align = 'center'
            obj2.type = 'fl'
            obj2.title = menu.alias
            obj2.scopedSlots = { customRender: obj2.dataIndex }
            // this.flColSlots.push(obj2.dataIndex)
          } else if (menu.istj) {
            // 统计字段
            obj2.align = 'right'
            obj2.type = 'tj'
            obj2.title = menu.unit ? `${menu.alias}(${menu.unit})` : menu.alias
            obj2.customRender = (text) => {
              return thousands(text,'false')
            }
          }else{
            // 显示字段
            obj2.title = menu.alias
            if(menu.groupOrNot){
              obj2.align = 'center'
            }else if(menu.statisticsOrNot){
              obj2.align = 'right'
            }
          }
          this.columnsDetail.push(obj2)
        }
        this.columnsDetail.push({
          title: '操作',
          dataIndex: 'action',
          scopedSlots: {customRender: 'action'},
          align: "center",
        })
        if(this.columnsDetail.length > 7){
          this.columnsDetail.map(item => {
            item.width = 130
          })
        }
        
        console.log('flColSlots',this.flColSlots,this.columnsAll);
        this.$nextTick(() => {
          let info = {
            colLength: this.columnsAll.length,
            mergeColIndex: this.calculateMergeCol(this.columnsAll.filter(e => e.type == 'fl').length),
            startChangeBgIndex: this.columnsAll.filter(e => e.type == 'fl').length - 2,
            rowClass: '.summaryInfoTable .ant-table-scroll .ant-table-tbody tr',
            ifNeedMergeCol:'false'
          }
          this.mergeCells(info)
          this.addListener()
        })

        document.addEventListener('keydown', this.handleKeyDown);
      },
      // esc键触发事件
      handleKeyDown(event) {
        // 监听到按下的键是Esc键（keyCode 27）时触发相应逻辑
        if (event.keyCode === 27) {
          if(this.ifFullScreen){
            this.ifFullScreen = false
          }
        }
      },
      // 统计信息 树结构展示
      showTree(){
        // 关闭图层管理的弹框
        this.$emit('closeLayerManageDialog')
        // 最小化统计信息弹框
        this.miniSize()
        // 展示树
        if(this.dataName != '综合'){
          // 说明选中的图层不是专题分析的综合图层
          this.currentTabInfo.alias = this.layerData.alias
        }
        this.$refs.staticInfoTreeDialog.open(this.currentTabInfo,this.flColSlots,this.geoserverUrl)
      },
      // 统计信息 表格展示
      showTable(){
        this.showMode = true
        this.$emit('closeMiniSizeDialog')
      },
      // 关闭
      close() {
        document.removeEventListener('keydown', this.handleKeyDown);
        this.cancelListener()
        this.$refs.marsModal && this.$refs.marsModal.close()
        this.$refs.staticInfoTreeDialog && this.$refs.staticInfoTreeDialog.handleClose()
        this.showMode = false
      },
      // 计算表体高度
      calculateTableHeight(){
        // 弹框高度
        let dialogHeight = document.querySelector('.summaryInformation').offsetHeight
        // 弹框标题
        let dialogTitleHeight = document.querySelector('.summaryInformation .ant-card-head').offsetHeight
        // 图斑切换按钮
        let polygonsHeight = document.querySelector('.summaryInformation .polygons') ? document.querySelector('.summaryInformation .polygons').offsetHeight : 0
        // 统计信息和详情的按钮
        let tabBtnsHeight = document.querySelector('.summaryInformation .tabBtns').offsetHeight
        // 表头
        let tableHeaderHeight = document.querySelector('.summaryInformation .ant-table-scroll .ant-table-header').offsetHeight
        // 分页按钮
        let paginationHeight = 0
        if(this.activeTabInfo == '2'){
          paginationHeight = document.querySelector('.summaryInformation .ant-pagination') ? document.querySelector('.summaryInformation .ant-pagination').offsetHeight : 0
        }
        let totalHeight = dialogTitleHeight + polygonsHeight + tabBtnsHeight + tableHeaderHeight + paginationHeight + 20
        this.tableHeight = (dialogHeight - totalHeight) + 'px'
        console.log('表体高度',this.tableHeight);
      },
      // 监听弹框的尺寸变化
      addListener(){
        this.wrapEle = document.querySelector('.wrap .summaryInformation');
        this.resizeObserver = new ResizeObserver(entries => {
          entries.forEach(entry => {
            this.calculateTableHeight()
          })
        });
        this.resizeObserver.observe(this.wrapEle);
        
        window.addEventListener('resize', this.resizeHandler);
      },
      // 取消监听
      cancelListener(){
        window.removeEventListener('resize', this.resizeHandler);

        this.resizeObserver && this.resizeObserver.disconnect()
        this.resizeObserver = null
      },
      // 取消
      cancel() {
        this.close()
      },
      // 全屏
      fullScreen(){
        this.ifFullScreen = !this.ifFullScreen
      },
      // 最小化
      miniSize() {
        this.$refs.marsModal && this.$refs.marsModal.close()
        this.showMode = false
        this.$emit('miniSizeMethod', {
          condition: this.condition,
          // condition: JSON.parse(this.condition),
          fwArry: this.fwArry,
          resData: this.tabArry,
          layerParams: this.layerParams,
          name: '汇总信息',
        })
      },
      // 切换图斑
      polygonChange(key) {
        this.activeTab = key
        this.activeTabInfo = '1'
        this.exportBsm = key
        this.currentTabInfo = this.tabArry.filter(data => data.bsm == key)[0]
        for (var item of this.tabArry) {
          if (item.bsm == key) {
            this.reportName = item.name
          }
        }

        this.$nextTick(() => {
          let info = {
            colLength: this.columnsAll.length,
            mergeColIndex: this.calculateMergeCol(this.columnsAll.filter(e => e.type == 'fl').length),
            startChangeBgIndex: this.columnsAll.filter(e => e.type == 'fl').length - 2,
            rowClass: `#${key} .ant-table-scroll .ant-table-tbody tr`,
            ifNeedMergeCol:'false'
          }
          this.mergeCells(info)
          this.calculateTableHeight()
        })
      },
      // 计算要合并哪些列
      calculateMergeCol(n) {
        const arr = Array.from({ length: n }, (_, index) => index);
        arr.push(n);
        return arr;
      },
      // 双击获取当前行详细的图层数据
      interLayerData(record, type) {
        let params = {}
        if(this.dialogTitle == '专题分析'){
          params.tcmc = record.tcmc
        }else{
          params.tcmc = this.layerName
        }
        params.bsm = record.bsm
        this.$emit('checkLayerAttrs',params)
      },
      // 重新加载图层
      reLoadGraphic() {
        if (this.graphicLayer) {
          this.graphicLayer.remove()
          this.graphicLayer = null
        }
        // 创建矢量数据图层
        this.graphicLayer = new mars3d.layer.GraphicLayer()
        this.map.addLayer(this.graphicLayer)
      },
      // 高亮区域方法
      addDemoGraphic1(graphicLayer, positions) {
        const graphic = new mars3d.graphic.PolygonEntity({
          positions: positions,
          style: {
            color: '#3388ff',
            opacity: 0.3,
            outline: true,
            outlineWidth: 3,
            outlineColor: '#ffffff',
            label: {
              text: '',
              font_size: 18,
              color: '#ffffff',
              distanceDisplayCondition: true,
              distanceDisplayCondition_far: 500000,
              distanceDisplayCondition_near: 0,
            },
          },
          flyTo: true,
          flyToOptions: {
            scale: 4,
            duration: 1.5,
          },
        })
        graphicLayer.addGraphic(graphic)
      },
      // 统计信息表格点击事件
      rowClickTjxx(record, index) {
        var _this = this
        return {
          on: {
            click: (e) => {
              _this.handleTableSingleClick(record,e)
            },
            dblclick: () => {
              _this.singleClick = false
              _this.clickCell(record)
            },
          },
        }
      },
      // 详情表格点击事件
      rowClickDetail(record, index) {
        var _this = this
        return {
          on: {
            click: (e) => {
              _this.handleTableSingleClick(record,e)
              // _this.index = index
              // _this.highlightRow2 = record.bsm
            },
            dblclick: () => {
              // _this.interLayerData(record, '1')
              _this.singleClick = false
              _this.clickCell(record)
            },
          },
        }
      },
      // 表格行单击事件的封装
      handleTableSingleClick(record,e){
        this.singleClick = true
        setTimeout(() => {
          if(this.singleClick){
            let clickValue = e.target.innerHTML
            let clickKey = ''
            if(clickValue && clickValue != '小计' && clickValue != '合计'){
              for (const key in record) {
                if (record[key] === clickValue) {
                  clickKey = key;
                  break;
                }
              }
              // 判断点击的是不是分类数据
              if(this.flColSlots.includes(clickKey)){
                this.clickCell(record,clickKey)
              }
              this.highlightRow = record.dlbm
            }
          }
        }, 200);
      },
      // 表格单元格点击事件
      clickCell(record,text){
        // text有值  说明是单击事件，没值是双击事件
        // 由于record里的键值对排序和表格列排序不一致，且包含分类 统计 显示字段，所以要做如下处理
        // console.log('单元格点击',record,text,this.flColSlots);
        let targetObj = {value:{},alias:''}
        // Object.fromEntries  将键值对数组转换为对象  
        let filteredObj = Object.fromEntries(
          // Object.entries()  返回对象自身可枚举属性的键值对数组
          Object.entries(record)
            // 过滤出分类数据
            .filter(([key]) => this.flColSlots.includes(key))
            // 把过滤出来的数据按照列的排列顺序进行排序
            .sort(([a], [b]) => this.flColSlots.indexOf(a) - this.flColSlots.indexOf(b))
        );
        targetObj.value = filteredObj
        if(text){
          // 如果是单击事件，只需要单击的列及其前面的列的数据
          var resultObj = {};
          for (const [key, value] of Object.entries(filteredObj)) {
            resultObj[key] = value;
            if (key === text) {
              break;
            }
          }
          targetObj.value = resultObj
        }
        targetObj.alias = this.layerData.alias
        this.showDetailsByAttr(targetObj)
      },
      // 点击单元格查询绘制范围内所有符合条件的图斑
      showDetailsByAttr(targetObj){
        const _this = this
        if(this.geoJsonLayer){
          this.map.removeLayer(this.geoJsonLayer)
        }
        this.geoJsonLayer = new mars3d.layer.GeoJsonLayer({
          name: '查询结果',
          symbol: {
            type: 'polygonP', //面
            styleOptions: {
              color: "#00ffff",
              opacity: 0.3,
              outline: true,
              outlineWidth: 1,
              outlineColor: "#00ffff",
              clampToGround: true, //贴地
              highlight: {
                type:'click',
                color: '#ffcc00',
                outline: true,
                outlineColor: '#64ff44',
              },
            },
          }
        })
        this.map.addLayer(this.geoJsonLayer)

        //移除总的分析图层
        let aliveLayer = this.map.getLayerByAttr('查询分析图层','name')
        if(aliveLayer){
          this.map.removeLayer(aliveLayer)
        }

        let geom
        // 如果是选择多个多边形需要用bsm区分然后传入参数进行查询
        if(this.fwArry.length > 1){
          if(this.fwArry[0].analysisType){
            geom = this.fwArry.find(item=>item.bsm == this.activeTab).bufferLayer
          }else{
            geom = this.fwArry.find(item=>item.bsm == this.activeTab)
          }
        }else if(this.fwArry.length == 1){
          if(this.fwArry[0].analysisType){
            geom = this.fwArry[0].bufferLayer;
          }else{
            geom = this.fwArry[0];
          }
        }
        
        console.log(geom);
        // 如果为空，不进行继续分析
        if(!geom){
          return
        }

        queryGeomByAttr(targetObj.geoserverUrl,targetObj.alias,targetObj.value,geom).then(res=>{
          // if(_this.methodsQuery == 2){
          //   let graphic = new mars3d.graphic.PolygonEntity({
          //     positions: geom.pointArry,
          //     style:geom.style
          //   })
          //   const drawGeoJSON = graphic.toGeoJSON({ outline: true })
          //   const arrFeatures = res.geojson.features
          //   for (let i = 0; i < arrFeatures.length; i++) {
          //     const feature = arrFeatures[i]
          //     try {
          //       const geojsonNew = turf.intersect(drawGeoJSON, feature) // 切割
          //       if (geojsonNew) {
          //         feature.geometry = geojsonNew.geometry
          //       }
          //     } catch (e) {
          //       this.$message.error("切割异常，请重新切割");
          //     }
          //   }
          // }
          _this.geoJsonLayer.load({data: res.geojson})
        })
        this.geoJsonLayer.on(mars3d.EventType.click,function(event) {
          // 属性
          let attributes = []
          let detailInfo = event.graphic.options.attr
          if(_this.dialogTitle == '专题分析'){
            attributes = _this.layerLists.filter(e => e.alias.split(':')[1].indexOf(record.tcmc) > -1 )[0].attributes
          }else{
            attributes = _this.layerData.attributes
          }
          _this.$refs.marsModal.showModal(detailInfo, '详情查看', attributes)
        })
      },
      // 切换 统计信息/详情  按钮
      tableBtnChange(key) {
        this.activeTabInfo = key
        this.showSingeDetail = false
        this.showAllDetail = true
        if (key == '2') {
          // 详情
          this.flAttrs = {}
          this.ipagination.current = 1
          this.tableLoading2 = true
          let url = this.dialogTitle == '专题分析' ? this.hturl.getZtfxDetail : this.hturl.getDetail
          let geom = this.layerParams.filter(item => item.bsm == this.activeTab)[0]
          let params = {
            conditionVOList: this.condition,
            geom: geom,
            // geom: this.layerParams[0],
            tcmc: this.layerName,
            algorithm: this.methodsQuery,
            size: this.ipagination.pageSize,
            current: this.ipagination.current,
          }
          this.tjxxTrInfo = JSON.parse(JSON.stringify(params))
          this.$emit('analysisCheckDetail','详情',params,this.dialogTitle)
        }else{
          this.tjxxTrInfo = {}
          this.$nextTick(() => {
            let info = {
              colLength: this.columnsAll.length,
              mergeColIndex: this.calculateMergeCol(this.columnsAll.filter(e => e.type == 'fl').length),
              startChangeBgIndex: this.columnsAll.filter(e => e.type == 'fl').length - 2,
              rowClass: '.summaryInfoTable .ant-table-scroll .ant-table-tbody tr',
              ifNeedMergeCol:'false'
            }
            this.mergeCells(info)
          })
          this.calculateTableHeight()
        }
      },
      // 获取详情数据
      getTableDetail() {
        if (this.tableData2.length > 0) {
          flzdmc = this.columnsDetail[0].dataIndex.toLowerCase()
          var totalArr = []
          var arr = []
          this.tableData2.forEach((item, index) => {
            arr.push(item)
            if (
              (this.tableData2[index + 1] && item[flzdmc] !== this.tableData2[index + 1][flzdmc]) ||
              !this.tableData2[index + 1]
            ) {
              arr.forEach((it, ind) => {
                if (ind === 0) {
                  it.rowSpan = arr.length
                } else {
                  it.rowSpan = 0
                }
              })
              totalArr.push(...arr)
              arr = []
            }
          })
          this.tableData2 = totalArr
        }
      },
      // 统计信息表格行 点击详情
      clickTableTrDetail(record) {
        console.log('查看详情', record, this.layerParams,this.condition)
        this.tjxxTrInfo = JSON.parse(JSON.stringify(record))
        this.activeTabInfo = '2'
        this.showSingeDetail = true
        this.showAllDetail = false
        this.tableLoading2 = true
        let obj = {}
        if(this.dialogTitle == '专题分析'){
          this.condition.forEach((item) => {
            if (item.isfl) {
              // 如果是分类字段
              let value = record[item.mc]
              obj[item.mc] = value
            }
          })
        }else{
          this.condition.forEach((item) => {
            if (item.groupOrNot) {
              // 如果是分类字段
              let value = record[item.name.toLowerCase()]
              obj[item.name.toLowerCase()] = value
            }
          })
        }
        this.flAttrs = obj
        this.interChexkDetail(record.tcmc)
      },
      // 查看详情 调接口
      interChexkDetail(tcmc) {
        let geom = this.layerParams.filter(item => item.bsm == this.activeTab)[0]
        let params = {
          conditionVOList: this.condition,
          map: this.flAttrs,
          geom: geom,
          // geom: this.layerParams[0],
          tcmc: tcmc ? tcmc : this.layerName,
          algorithm: this.methodsQuery,
          size: this.ipagination.pageSize,
          current: this.ipagination.current,
        }
        this.$emit('analysisCheckDetail','表格行详情',params,this.dialogTitle)
      },
      // 详情表格行 点击详细
      toCheckDetail(record) {
        this.interLayerData(record, '2')
      },
      // 导出 弹出截图弹框
      exportInfo() {
        this.exportLoading = true
        this.operate = '导出'
        this.$refs.screenShotDialog.open()
      },
      // 点击导出  拿到截图后的操作
      handleExport(file){
        console.log('file',file,this.activeTab,this.layerParams);
        let geom = this.layerParams.filter(item => item.bsm == this.activeTab)[0]
        console.log('geom',geom);
        let formData = new FormData()
        if (this.activeTabInfo == '1') {
          // 统计信息
          let params = {
            geoms: [geom],
            algorithm: this.methodsQuery,
          }
          if(this.dialogTitle == '专题分析'){
            params.ztName = this.ztName
            params.tcmcList = this.layerName.split(',')
          }else{
            params.tcmc = this.layerName
            params.conditionVOList = this.condition
          }
          formData.append('request',JSON.stringify(params))
          formData.append('file',file)
          console.log('json1',params)
          this.$emit('analysisExport', '统计信息', {formData:formData,reportName:geom.name}, this.dialogTitle);
          // let url = this.dialogTitle == '专题分析' ? this.hturl.exportZtfxAll : this.hturl.exportAll
          // downFilePost_ds(url, formData, null).then((res) => {
          //   this.goExportExcel(res)
          // })
        } else {
          // 详情
          let params = {
            geom: geom,
            algorithm: this.methodsQuery,
            conditionVOList: this.condition
          }
          if (!this.showAllDetail) {
            // 页面展示的是单个分类的详情数据
            params.map = this.flAttrs
          }
          if(this.dialogTitle == '专题分析'){
            params.ztName = this.ztName
            params.tcmc = this.layerName
          }else{
            params.tcmc = this.layerName
          }
          formData.append('request',JSON.stringify(params))
          formData.append('file',file)
          console.log('json2',params)
          this.$emit('analysisExport', '详情', {formData:formData,reportName:geom.name},this.dialogTitle);
          // let url = this.dialogTitle == '专题分析' ? this.hturl.exportZtfxDetail : this.hturl.exportDetail
          // downFilePost_ds(url, formData, null).then((res) => {
          //   this.goExportExcel(res)
          // })
        }
      },
      // 导出excel封装方法
      goExportExcel(res) {
        console.log('res',res);
        let url = window.URL.createObjectURL(
          new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        )
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', this.reportName + '统计信息数据')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link) //下载完成移除元素
        window.URL.revokeObjectURL(url) //释放掉blob对象
        this.exportLoading = false
      },
      // 保存分析结果
      saveInfo() {
        this.collectLoading = true
        this.operate = '收藏'
        this.$refs.screenShotDialog.open()
      },
      // 截图的回调
      handleShot(file) {
        this.collectLoading = false
        if(!file){
          // 说明点击的是取消或关闭截图
          this.exportLoading = false
          return
        }
        if(this.operate == '收藏'){
          this.$refs.saveAnalysisDialog.setMap(this.fwArry, this.condition, this.dialogTitle, this.methodsQuery, file,'', '', this.projectBsm,this.pageKey)
        }else if(this.operate == '导出'){
          this.handleExport(file)
        }
      },
      // 分页改变方法
      handleTableChange(pagination) {
        this.ipagination = pagination
        this.clickTableTrDetail(this.tjxxTrInfo)
      },
      // 关闭详细弹窗
      closeDetails(){
        if(this.graphicLayer){
          this.map.removeLayer(this.graphicLayer)
        }
        if(this.map){
          this.map.closeHighlight()
        }
      },
    },
  }
</script>
  
<style lang="less" scoped>
.container {
  position: absolute;
  top: 20%;
  right: 48%;
}
.wrap {
  margin-top: 12px;
  border: none;
  /deep/.handle {
    width: 20px;
    border-radius: 10px;
    height: 20px;
    background: rgba(240, 240, 240, 0.6);
    border: 1px solid #ccc;
    z-index: 2;
  }
  position: absolute;
  // top: 20%;
  // right: 10px;
  // left: -185%;
  z-index: 1 !important;
  padding: 0;
  border-radius: 4px;
  .summaryInformation {
    width: 100%;
    height: 100%;
    border-radius: 4px;
    border: 1px solid rgba(128, 128, 128, 0.5);
    color: #ffffff;
    /deep/.ant-card-head {
      min-height: 46px;
      padding: 0;
      cursor: all-scroll;
      .ant-card-extra {
        padding: 8px 10px;
      }
      .ant-card-head-title {
        padding: 0;
      }
      border-bottom: none;
    }
    /deep/ .ant-card-head {
      height: 46px;
      line-height: 46px;
      cursor: move;
      overflow: hidden;
      color: #fff;
    }
    /deep/ .ant-card-head-wrapper {
      background-color: transparent;
      line-height: 30px;
    }
    /deep/.ant-card-body {
      padding: 0 0 10px 0;
    }
    /deep/.ant-descriptions-item-label,
    /deep/.ant-descriptions-item-content {
      word-break: break-all;
      min-width: 100px;
      color: #fff;
    }
    /deep/.ant-card-extra a {
      font-size: 16px;
    }
    /deep/ .ant-descriptions-item-label {
      padding: 5px 12px;
      background-color: transparent;
    }
    .headerClass {
      width: 100%;
      height: 46px;
      line-height: 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid rgba(255, 255, 255, 0.20);
      padding: 0;
      .spanClass {
        color: #27f181;
      }
      .oprateBtn {
        display: flex;
        justify-content: space-between;
        .exportBtn {
          color: #ffffff; 
          background-color: rgba(15, 97, 255, 0.50); 
          border: 0
        }
        .collectBtn {
          color: #ffffff; 
          background-color: rgba(0, 201, 129, 0.50); 
          border: 0; 
          margin: 0 10px
        }
        .anticon-minus {
          margin-right: 10px;
        }
      }
    }
    .contentInfo {
      width: 100%;
      height: 100%;
      .polygons {
        height: 40px;
        line-height: 40px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.20);
        margin-bottom: 10px;
        span {
          cursor: pointer;
          color: rgba(255, 255, 255, 0.50);
          &:last-child div {
            display: none;
          }
        }
        .activePolygon {
          color: #fff;
        }
      }
      .tabBtns {
        span {
          display: inline-block;
          width: 90px;
          height: 30px;
          text-align: center;
          line-height: 30px;
          cursor: pointer;
          margin: 10px 0;
          &:last-child {
            margin-left: 1px;
          }
        }
        .btn {
          background: rgba(255, 255, 255, 0.50);
        }
      }
    }
  }
}
#fullscreenDialog {
  width: 100% !important;
  height: 100% !important;
  top: 0;
  right: 0;
  z-index: 10001 !important;
  margin-top: 0;
  transform: translate(0, 0) !important;
}

.summaryInformation input,
.summaryInformation select,
.summaryInformation textarea {
  color: #ffffff;
  border: 1px solid #e4eaec;
  font-size: 14px;
}
/deep/ .ant-tabs-card .ant-tabs-bar .ant-tabs-tab {
  background: transparent !important;
  box-shadow: none !important;
}
/deep/ .ant-tabs-bar {
  border-bottom: 1px solid rgba(255, 255, 255, 0.20);
}
/deep/ .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab {
  height: 30px !important;
  line-height: 30px !important;
}
/deep/ .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-nav-container {
  height: 30px !important;
}
/deep/ .ant-tabs,
/deep/ .ant-tabs-tabpane,
/deep/ .tableHeaderClass,
/deep/ .ant-table-scroll {
  height: 100%;
}
/deep/ .contentInfo > .ant-tabs > .ant-tabs-content {
  height: 90% !important;
}
/deep/ .ant-tabs-content {
  height: calc(100% - 60px);
}
/deep/ .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active.ant-tabs-tab {
  background: transparent !important;
  box-shadow: none !important;
}
/deep/ .ant-pagination-item-ellipsis {
  color: #fff !important;
}
/deep/ td {
  cursor: pointer;
}
</style>
  